import { render, staticRenderFns } from "./birthdaysPage.vue?vue&type=template&id=4524a384&scoped=true&"
import script from "./birthdaysPage.vue?vue&type=script&lang=js&"
export * from "./birthdaysPage.vue?vue&type=script&lang=js&"
import style0 from "./birthdaysPage.vue?vue&type=style&index=0&id=4524a384&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524a384",
  null
  
)

export default component.exports